import React from 'react';
import { Button as ButtonComponent } from '@mui/material';

export const Button: React.SFC<any> = ({ children, ...props }) => (
  <ButtonComponent {...props}>{children}</ButtonComponent>
);
